// @ts-strict-ignore
import { ArrayUtils } from './array-utils';
import { NumberUtils } from './number-utils';
import { Dictionary } from 'typescript-collections';
import { TextSizeCheckVO } from '@3d-scene/manager/text-size-check.vo';

export class CellLabelSizeInfoUtils {

  public static getMultiLineAdjustedCellLabelSizeInfos(cellLabelSizeInfos: TextSizeCheckVO[], multiLineCount: number,
                                                       rotation: number): TextSizeCheckVO[] {
    if (multiLineCount === 1 || ArrayUtils.isEmpty(cellLabelSizeInfos) || NumberUtils.isNotNumber(rotation)) {
      return cellLabelSizeInfos;
    }
    const inputKeyToCellLabelSizeInfo: Dictionary<string, TextSizeCheckVO> = new Dictionary<string, TextSizeCheckVO>();
    const inputKeyToDistance: Dictionary<string, number> = new Dictionary<string, number>();
    for (const cellLabelSizeInfo of cellLabelSizeInfos) {
      let adjustedCountTarget: number = rotation === 0 ? cellLabelSizeInfo.lines : cellLabelSizeInfo.chars;
      adjustedCountTarget = adjustedCountTarget / multiLineCount;
      const adjustedCount: number = Math.floor(adjustedCountTarget);
      if (adjustedCount === 0) {
        continue;
      }
      const distance: number = adjustedCountTarget - adjustedCount;
      const adjustedCellLabelSizeInfo: TextSizeCheckVO = cellLabelSizeInfo.createAlteredInstance(
        rotation === 0 ? adjustedCount : cellLabelSizeInfo.lines,
        rotation === 0 ? cellLabelSizeInfo.chars : adjustedCount
      );
      const inputKey: string = adjustedCellLabelSizeInfo.getUniqueKeyBasedOnAllInputTextSizeProperties();
      let useCurrentCellLabelSizeInfo: boolean = false;
      if (inputKeyToDistance.containsKey(inputKey)) {
        const existingDistance: number = inputKeyToDistance.getValue(inputKey);
        if (existingDistance > distance) {
          useCurrentCellLabelSizeInfo = true;
        }
      } else {
        useCurrentCellLabelSizeInfo = true;
      }
      if (useCurrentCellLabelSizeInfo) {
        inputKeyToCellLabelSizeInfo.setValue(inputKey, adjustedCellLabelSizeInfo);
        inputKeyToDistance.setValue(inputKey, distance);
      }
    }
    const result: TextSizeCheckVO[] = [];
    inputKeyToCellLabelSizeInfo.forEach((key: string, value: TextSizeCheckVO) => {
      result.push(value);
    });
    return result;
  }

}
